// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Waiting-module__wrapper___jIDHz {
  display: flex;
  width: 1238px;
  padding: 30px 60px;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  border-radius: 42px;
  background: #EEE;
  background: var(--element-bg, #EEE);
}

.Waiting-module__title___DBaxc {
  display: flex;
  gap: 20px;
  height: 194px;
  width: 1076px;
  text-align: center;
  flex-direction: column;
  align-items: center;
}

.Waiting-module__textBig___H3FAS {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  width: 885px;
}
.Waiting-module__textBig___H3FAS span {
  color: var(--color-primary);
}

.Waiting-module__text___SvnuP {
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.4;
}

.Waiting-module__rede___v753h {
  color: #41C4C4;
  color: var(--primary, #41C4C4);
  font-family: Inter;
  height: 45px;
  font-size: 40px;
  font-weight: 600;
}

.Waiting-module__case___Hfvhw{
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
}

.Waiting-module__topic___sYjXZ{
  display: flex;
  gap: 30px;
  align-items: center;
}

.Waiting-module__img___eKwgj {
  width: 88px;
  height: 88px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.Waiting-module__code___jB6Dh{
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
}

.Waiting-module__wrap___jGNaP {
  display: flex;
  background: #FFF;
  gap: 24px;
  width: 1118px;
  border-radius: 42px;
  padding-top: 40px;
  padding-bottom: 32px;
  flex-direction: column;
  align-items: center;
}

.Waiting-module__container___r_5ZK {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 20px;
}

.Waiting-module__scriptBig___T8z_a{
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
}

.Waiting-module__link___T25a7{
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: var(--color-primary); 
}
.Waiting-module__link___T25a7:hover{
  color: var(--color-black);
}

.Waiting-module__script___G4iut{
  display: flex;
  flex-direction: column;
  text-align: center;
  font-family: Inter;
  width: 940px;
  font-size: 20px;
  font-weight: 400;
}

@media (min-width: 768px) and (max-width: 1199px) { 
  .Waiting-module__wrapper___jIDHz {
    width: 692px;
    padding: 34px 30px;
  }
  
  .Waiting-module__title___DBaxc {
    display: flex;
    gap: 20px;
    width: 635px;
    text-align: center;
    flex-direction: column;
    align-items: center;
  }
  
  .Waiting-module__textBig___H3FAS {
    font-size: 16px;
    width: 635px;
  }
  
  .Waiting-module__text___SvnuP {
    font-size: 16px;
    width: 574px;
  }
  
  .Waiting-module__rede___v753h {
    font-size: 25px;
    height: 28px;
  }
  
  .Waiting-module__case___Hfvhw{
    gap: 20px;
  }
  
  .Waiting-module__topic___sYjXZ{
    display: flex;
    gap: 20px;
    align-items: center;
  }
  
  .Waiting-module__img___eKwgj {
    width: 61px;
    height: 61px;
    margin-top: inherit;
    margin-bottom: inherit;
  }
  
  .Waiting-module__code___jB6Dh{
    font-size: 25px;
  }
  
  .Waiting-module__wrap___jGNaP {
    gap: 15px;
    width: 632px;
    height: 291px;
    padding-top: 20px;
  }
  
  .Waiting-module__container___r_5ZK {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .Waiting-module__scriptBig___T8z_a{
    font-size: 16px;
  }

  .Waiting-module__link___T25a7{
    font-size: 16px;
  }
  
  .Waiting-module__script___G4iut{
    font-size: 16px;
    width: 608px;
  }
}

@media (min-width: 360px) and (max-width: 767px) {
  .Waiting-module__wrapper___jIDHz {
    width: 324px;
    padding: 30px 18px;
  }
  
  .Waiting-module__title___DBaxc {
    display: flex;
    gap: 20px;
    width: 288px;
    height: auto;
    height: initial;
    text-align: center;
    flex-direction: column;
    align-items: center;
  }
  
  .Waiting-module__textBig___H3FAS {
    font-size: 14px;
    width: 288px;
  }
  
  .Waiting-module__text___SvnuP {
    font-size: 14px;
    width: 230px;
  }
  
  .Waiting-module__rede___v753h {
    font-size: 20px;
  }
  
  .Waiting-module__case___Hfvhw{
    gap: 20px;
    width: 288px;
  }
  
  .Waiting-module__topic___sYjXZ{
    display: flex;
    gap: 20px;
    align-items: center;
  }
  
  .Waiting-module__img___eKwgj {
    width: 42px;
    height: 42px;
    margin-top: inherit;
    margin-bottom: 9px;
  }
  
  .Waiting-module__code___jB6Dh{
    font-size: 20px;
  }
  
  .Waiting-module__wrap___jGNaP {
    gap: 15px;
    width: 288px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  
  .Waiting-module__container___r_5ZK {
    width: 264px;
  }
  
  .Waiting-module__scriptBig___T8z_a{
    font-size: 14px;
  }

  .Waiting-module__link___T25a7{
    font-size: 14px;
  }
  
  .Waiting-module__script___G4iut{
    font-size: 14px;
    width: 264px;
  }
}`, "",{"version":3,"sources":["webpack://./src/widgets/waiting/ui/Waiting.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAAqB;EAArB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,YAAY;IACZ,YAAe;IAAf,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  width: 1238px;\n  padding: 30px 60px;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px;\n  border-radius: 42px;\n  background: var(--element-bg, #EEE);\n}\n\n.title {\n  display: flex;\n  gap: 20px;\n  height: 194px;\n  width: 1076px;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.textBig {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.4;\n  width: 885px;\n}\n.textBig span {\n  color: var(--color-primary);\n}\n\n.text {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.rede {\n  color: var(--primary, #41C4C4);\n  font-family: Inter;\n  height: 45px;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.case{\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  width: 100%;\n}\n\n.topic{\n  display: flex;\n  gap: 30px;\n  align-items: center;\n}\n\n.img {\n  width: 88px;\n  height: 88px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.code{\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.wrap {\n  display: flex;\n  background: #FFF;\n  gap: 24px;\n  width: 1118px;\n  border-radius: 42px;\n  padding-top: 40px;\n  padding-bottom: 32px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  gap: 20px;\n}\n\n.scriptBig{\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.link{\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 700;\n  text-decoration: none;\n  color: var(--color-primary); \n}\n.link:hover{\n  color: var(--color-black);\n}\n\n.script{\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  font-family: Inter;\n  width: 940px;\n  font-size: 20px;\n  font-weight: 400;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) { \n  .wrapper {\n    width: 692px;\n    padding: 34px 30px;\n  }\n  \n  .title {\n    display: flex;\n    gap: 20px;\n    width: 635px;\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .textBig {\n    font-size: 16px;\n    width: 635px;\n  }\n  \n  .text {\n    font-size: 16px;\n    width: 574px;\n  }\n  \n  .rede {\n    font-size: 25px;\n    height: 28px;\n  }\n  \n  .case{\n    gap: 20px;\n  }\n  \n  .topic{\n    display: flex;\n    gap: 20px;\n    align-items: center;\n  }\n  \n  .img {\n    width: 61px;\n    height: 61px;\n    margin-top: inherit;\n    margin-bottom: inherit;\n  }\n  \n  .code{\n    font-size: 25px;\n  }\n  \n  .wrap {\n    gap: 15px;\n    width: 632px;\n    height: 291px;\n    padding-top: 20px;\n  }\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    gap: 20px;\n  }\n  \n  .scriptBig{\n    font-size: 16px;\n  }\n\n  .link{\n    font-size: 16px;\n  }\n  \n  .script{\n    font-size: 16px;\n    width: 608px;\n  }\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n  .wrapper {\n    width: 324px;\n    padding: 30px 18px;\n  }\n  \n  .title {\n    display: flex;\n    gap: 20px;\n    width: 288px;\n    height: initial;\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .textBig {\n    font-size: 14px;\n    width: 288px;\n  }\n  \n  .text {\n    font-size: 14px;\n    width: 230px;\n  }\n  \n  .rede {\n    font-size: 20px;\n  }\n  \n  .case{\n    gap: 20px;\n    width: 288px;\n  }\n  \n  .topic{\n    display: flex;\n    gap: 20px;\n    align-items: center;\n  }\n  \n  .img {\n    width: 42px;\n    height: 42px;\n    margin-top: inherit;\n    margin-bottom: 9px;\n  }\n  \n  .code{\n    font-size: 20px;\n  }\n  \n  .wrap {\n    gap: 15px;\n    width: 288px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n  \n  .container {\n    width: 264px;\n  }\n  \n  .scriptBig{\n    font-size: 14px;\n  }\n\n  .link{\n    font-size: 14px;\n  }\n  \n  .script{\n    font-size: 14px;\n    width: 264px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Waiting-module__wrapper___jIDHz`,
	"title": `Waiting-module__title___DBaxc`,
	"textBig": `Waiting-module__textBig___H3FAS`,
	"text": `Waiting-module__text___SvnuP`,
	"rede": `Waiting-module__rede___v753h`,
	"case": `Waiting-module__case___Hfvhw`,
	"topic": `Waiting-module__topic___sYjXZ`,
	"img": `Waiting-module__img___eKwgj`,
	"code": `Waiting-module__code___jB6Dh`,
	"wrap": `Waiting-module__wrap___jGNaP`,
	"container": `Waiting-module__container___r_5ZK`,
	"scriptBig": `Waiting-module__scriptBig___T8z_a`,
	"link": `Waiting-module__link___T25a7`,
	"script": `Waiting-module__script___G4iut`
};
export default ___CSS_LOADER_EXPORT___;
